import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { PAGE_SIZE_OPTIONS, PAGE_LENGTH, ITEMS_PER_PAGE, CURRENT_PAGE } from 'src/app/shared/constants/pagination.constants';
import { LeavesService } from 'src/app/modules/leaves/services/leaves.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatTableDataSource } from '@angular/material/table';
import { LeaveTypesCreateComponent } from '../leave-types-create/leave-types-create.component';
import { LeaveTypesService } from '../../services/leave-types.service';
import { LoaderService } from 'src/app/auth/services/loader.service';

const dialogConfig= new MatDialogConfig();
dialogConfig.disableClose = true;
dialogConfig.autoFocus = true;

@Component({
  selector: 'app-leave-types-details',
  templateUrl: './leave-types-details.component.html',
  styleUrls: ['./leave-types-details.component.css']
})
export class LeaveTypesDetailsComponent implements OnInit {

  @ViewChild('paginator', {static: true}) paginator: MatPaginator;

  displayedColumns: string[] = ['org_name', 'leave_type', 'leave_type_desc','added_date'];
 
  public PAGE_SIZE_OPTIONS_DATA:number[] = PAGE_SIZE_OPTIONS;

  public page_length:number = PAGE_LENGTH;

  public items_per_page:number = ITEMS_PER_PAGE;

  public current_page:number = CURRENT_PAGE;

  public leavesDataSource:any;

  
  constructor(
    private leaveTypeService:LeaveTypesService,
    private dialog:MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private loaderService:LoaderService

  ) { }

  ngOnInit(): void {
    this.loadIcon();
    this.getLeaves();

  }

  ngAfterViewInit(){
    if(this.leavesDataSource != undefined){
      this.leavesDataSource.paginator = this.paginator;
    }
  }

  loadIcon():void{
    this.matIconRegistry.addSvgIcon(
      "filter",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/SVG/filter.svg")
      );
  }

  getLeaves():void{
    this.loaderService.isTableLoding.next(true);

    let filterParams = this.addFilterParameters();
    this.leaveTypeService.getLeaveTypes(filterParams).subscribe(
      (res)=>{
        // console.log(`Responsive Data :: `,res);
        this.loaderService.isTableLoding.next(false);

        this.page_length = res.headers.get('X-Pagination-Total-Count');
        this.current_page = res.headers.get('X-Pagination-current-page');
        this.items_per_page = res.headers.get('X-Pagination-Per-Page');
        this.leavesDataSource = new MatTableDataSource<any>(res.body);

      }
    );
  }
  
  createLeave():void{
    dialogConfig.width ="40%";
    dialogConfig.data = {
      holiday_id : undefined
    };
    
    this.dialog.open(LeaveTypesCreateComponent,dialogConfig);

    // UPDATE CONTACT DETAILS AFTER CREATING THE CONTACT
    this.dialog.afterAllClosed.subscribe(e=>{
      this.getLeaves();
    });
  }

  addFilterParameters():Object{
    let filterParams = {};
    filterParams['page']=this.current_page;
    filterParams["per-page"]=this.items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }

  handlePage(e?: any):void {
    if(e){
      this.current_page = e.pageIndex+1;
      this.items_per_page = e.pageSize;
      this.page_length = e.length;
    }
    this.getLeaves();
  }

}

